import { Group, GroupAPI } from '@brg/api';
import { useEffect, useState, useCallback } from 'react';
import { computeGroup } from 'shared/helpers/types/computed/ComputedGroup';

export const useTeamGroups = (id: string , date: number, lang?: string, disabled?: boolean) => {
    const [data, setData] = useState<Group<'Global'>[]>([]);

    const fetchGroups = useCallback((id: string) => {
        //@ts-ignore
        GroupAPI.GetByTeamId({ teamId: id })
        .then((r: any) => {
            return r.json()
        })
        //@ts-ignore
        .then((r) => {
            if (!!r?.length) {
                //@ts-ignore
                setData(r?.map((g) => computeGroup(g)))
                return;
            }

            setData([])
        })
        .catch((error) => {
            console.error('Error fetching groups:', error);
            setData([]);
        })
    }, []); 

    const refreshGroups = useCallback(() => {
        if (!!id?.length && !disabled) {
            fetchGroups(id);
        }
    }, [id, disabled, fetchGroups]);

    useEffect(() => {
        if (!!id?.length && !disabled) {
            fetchGroups(id)
        } 
    } , [id, date, disabled, fetchGroups])

    if (!id?.length || disabled) {
        return { groups: [], refreshGroups: () => {} }
    }

    return { groups: data, refreshGroups };
}import { Group, GroupAPI } from '@brg/api';
import { useEffect, useState, useCallback } from 'react';
import { computeGroup } from 'shared/helpers/types/computed/ComputedGroup';

export const useTeamGroups = (id: string , date: number, lang?: string, disabled?: boolean) => {
    const [data, setData] = useState<Group<'Global'>[]>([]);

    const fetchGroups = useCallback((id: string) => {
        //@ts-ignore
        GroupAPI.GetByTeamId({ teamId: id })
        .then((r: any) => {
            return r.json()
        })
        //@ts-ignore
        .then((r) => {
            if (!!r?.length) {
                //@ts-ignore
                setData(r?.map((g) => computeGroup(g)))
                return;
            }

            setData([])
        })
        .catch((error) => {
            console.error('Error fetching groups:', error);
            setData([]);
        })
    }, []); 

    const refreshGroups = useCallback(() => {
        if (!!id?.length && !disabled) {
            fetchGroups(id);
        }
    }, [id, disabled, fetchGroups]);

    useEffect(() => {
        if (!!id?.length && !disabled) {
            fetchGroups(id)
        } 
    } , [id, date, disabled, fetchGroups])

    if (!id?.length || disabled) {
        return { groups: [], refreshGroups: () => {} }
    }

    return { groups: data, refreshGroups };
}